import {env} from "../../../../../res/config/env";
import solrField from "../../../../logic/search/solrField";
import HttpClient from "../../../http/HttpClient";

const getProductCondition = (productIDs) => {
    return productIDs
        .reduce((str, id) => {
            const cond = "(matchingProducts:" + id + ")";
            return str ? (str + "OR" + cond) : cond;
        }, null);
}

const buildValueRequestUrl = ({ categoryID, productIDs }) => {

    const url = env.API_SOLR_URL;
    const select = "select?q="

    const paramList = "(Table_Name:filter_value)";
    const categoryCond = categoryID ? "AND(categoryChain:"+categoryID+")" : "";
    const productCond = productIDs ? "AND(" + getProductCondition(productIDs) + ")" : ""

    const pageSize = "&rows=" + 1000

    return url + select + paramList + categoryCond + productCond + pageSize;
}

const buildAttributeRequestUrl = () => {

    const url = env.API_SOLR_URL;
    const select = "select?q="

    const paramList = "(Table_Name:filter_attribute)";

    const pageSize = "&rows=" + 200

    return url + select + paramList + pageSize;
}

const formatAttribute = (rawAttribute) => {

    const attribute = {};

    attribute.type  = solrField.getValue(rawAttribute, "attributeType");
    attribute.setID = solrField.getValue(rawAttribute, "m_attributeSet_ID");
    attribute.id    = solrField.getValue(rawAttribute, "m_attribute_ID");
    attribute.name  = solrField.getValue(rawAttribute, "name");
    attribute.use   = rawAttribute.use?.map(l => [l.split("-")]);

    return attribute;
}

const formatValue = (rawValue) => {

    const value = {};

    value.setID             = solrField.getValue(rawValue, "m_attributeSet_ID");
    value.attributeID       = solrField.getValue(rawValue, "m_attribute_ID");
    value.seqNo             = solrField.getValue(rawValue, "seqNo");
    value.name              = solrField.getValue(rawValue, "value");
    value.categoryChain     = rawValue.categoryChain;
    value.referenceIDs      = rawValue.matchingProducts;

    return value;
}

const solrFiltersRequest = () => {

    const requestBuilder = {};
    const params = {};

    requestBuilder.setCategoryID = (categoryID) => {
        params.categoryID = categoryID;
        return requestBuilder;
    }

    requestBuilder.setProductIDs = (...productIDs) => {
        params.productIDs = productIDs;
        return requestBuilder;
    }

    requestBuilder.sendRequest = async () => {
        const valueUrl = buildValueRequestUrl(params);
        const valueRes = await HttpClient.client.get(valueUrl);
        const valueResponse = valueRes.data.response;

        const attrUrl = buildAttributeRequestUrl(params);
        const attrRes = await HttpClient.client.get(attrUrl);
        const attrResponse = attrRes.data.response;

        return {
            attributes: attrResponse.docs.map(formatAttribute),
            values: valueResponse.docs.map(formatValue)
        }
    }

    return requestBuilder;
}

export default solrFiltersRequest;
